export default __webpack_public_path__ + "static/media/carousel3_icon.05b67eb8.png";